import React from 'react'
import PropTypes from 'prop-types'
import styles from './Tree.css'

const BasicLeafNodeRenderer = ({ node, onClick, getName }) => {
  const clickHandler = () => onClick && onClick(node)
  return (
    <div className={styles.baseItem} onClick={clickHandler}>
      {getName(node) || ''}
    </div>
  )
}

BasicLeafNodeRenderer.propTypes = {
  node: PropTypes.object,
  onClick: PropTypes.func,
  getName: PropTypes.func,
}

export default BasicLeafNodeRenderer



// WEBPACK FOOTER //
// ../src/components/Tree/BasicLeafNodeRenderer.js